// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__u815U","logo":"loading_logo__RQqhj","fade":"loading_fade__3WPWI","text":"loading_text__TKrpy"};